<template>
  <div class="email-kb-container">
    <div class="email-kb-select-box">
      <!-- {{ extractedTags }} -->
      <!-- <SelectBoxWithIconVue
        :selectedValue="store.state.Emails.tagsFilter"
        :dataSource="extractedTags"
        @selectedItem="addFilter"
      /> -->
    </div>
    <div v-if="totalPages > 1" class="email-kb-select-box" style="margin-top: 70px; padding: 10px">
      <Pagination v-model="currentPage" :totalPages="totalPages" />
    </div>

    <div class="email-kb-select-box" style="margin-top: 120px; padding: 10px">
      <div v-for="(view, index) in viewOptions" :key="index"  v-if="!shouldShowLoader">
        <div
          class="tooltip-container"
          :class="{ selected: selectedView === view.mode }"
        >
          <img
            class="kbChoice"
            @click="switchHierarchView(view.mode)"
            :src="view.icon"
          />
          <span class="tooltip">{{ view.tooltip }}</span>
        </div>
        <br />
      </div>
    </div>
    <div class="tree-view-container">
      <div>
        <SearchBar ref="searchBarRef" />
      </div>
      <!-- No search results message -->
      <div v-if="showNoSearchResults" class="no-search-results">
        <div class="no-results-icon">🔍</div>
        <div class="no-results-text">
          <h3>No search results found</h3>
          <p>
            Try adjusting your search terms or clearing the search to see all
            items.
          </p>
        </div>
      </div>
      <SkeletonLoader
        v-if="shouldShowLoader"
        :itemCount="7"
        :hasChildren="true"
      />
      <DxTreeView
        :dataSource="treeViewData"
        data-structure="plain"
        key-expr="id"
        parent-id-expr="parentId"
        has-items-expr="hasItems"
        display-expr="name"
        :expandNodesRecursive="false"
        ref="treeViewInstance"
        id="simple-treeview"
        @item-click="selectItem"
        @item-expanded="maintainScrollPosition"
      >
        <template #item="item">
          <div class="flex">
            <span v-if="item.data.icon || item.data.emoji">
              <i
                v-if="item.data.hasItems && !item.data.expanded"
                class="dx-icon-chevronright bigger placement-to-left-of-node"
              ></i>
              <DxLoadIndicator
                v-if="item.data.id == clickedParentId"
                class="placement-to-left-of-node"
                id="small-indicator"
                :height="20"
                :width="20"
              />
              <ModelTag
                :TagsList="[item.data.icon]"
                :Emoji="item.data.emoji"
                :LargeIcon="item.data.parentId == null"
              />
            </span>
            <div class="text">
              <span>
                {{ item.data.name }}
              </span>
            </div>
            <span style="padding-left: 10px" v-if="item.data.modelTags">
              <ModelTag
                :LargeIcon="false"
                :Emoji="item.data.emoji"
                :TagsList="item.data.modelTags.tagsList.map((tag) => tag.type)"
              />
            </span>
          </div>
        </template>
      </DxTreeView>
      <!--
      FOR VIDEOS needs to be       height="auto"
        width="auto"
      -->
      <DxPopup
        :title="documentName"
        :on-hiding="closeCard"
        :drag-enabled="false"
        :closeOnOutsideClick="true"
        v-model:visible="showPopup"
        :show-close-button="true"
        :autoResizeEnabled="true"
        :resizeEnabled="false"
        :height="popupH"
        :width="popupWidth"
        :wrapper-attr="{ class: 'document-popup' }"
      >
        <div>
          <component
            :is="currentComponent"
            v-bind="componentProps"
            class="inside-div"
            :key="documentName"
          />
        </div>
      </DxPopup>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watchEffect, watch, nextTick, markRaw, onMounted } from "vue";
import { useStore } from "vuex";
import { DxTreeView } from "devextreme-vue/tree-view";
import ModelTag from "./TagRenderer.vue";
import EmailCard from "./EmailCard.vue";
import DxPopup from "devextreme-vue/popup";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import DocumentViewer from "../DocumentDisplay/DocumentViewer.vue";
import UserViewer from "../DocumentDisplay/UserViewer.vue";
import SelectBoxWithIconVue from "../UserSelectable/SelectBoxWithIcon.vue";
import Pagination from '../UserSelectable/Pagination.vue'
import SearchBar from "./SearchBar.vue";
import SkeletonLoader from "../UX/skeleton-loader.vue";

import filesIcon from "../../assets/icons/files2.png";
import chatIcon from "../../assets/icons/chat2.png";
import contactIcon from "../../assets/icons/contact.png";
import mailboxIcon from "../../assets/icons/mailbox.png";
import classificationIcon from "../../assets/icons/classification.png";

const extractedTags = computed(() => store.getters.extractedTags);

const store = useStore();
const treeViewInstance = ref(null);
const searchBarRef = ref(null);
const clickedParentId = ref(null); // Store clicked parent node ID for opening the right node once children have been fetched.

const currentComponent = ref(null);

const selectedView = ref(null); // Track the selected view
const isLoading = ref(true);

const currentPage = ref(1)
const totalPages = computed(() => store.getters.totalPages);

onMounted(() => {
  // Set loading to false once initial data is loaded
  if (treeViewData.value.length > 0) {
    isLoading.value = false;
  }
});

function switchHierarchView(mode) {
  // If in search mode, clear the search first
  if (KBInSearchMode.value && searchBarRef.value) {
    searchBarRef.value.clearSearch();
  }
  
  selectedView.value = mode; // Set the selected view
  store.commit("heirarchyMode", mode); //mutation
  store.commit("nodeIdSelected", "0");
  store.commit("setEmailKnowledgeBase", []);
  store.dispatch("emailKnowledgeBaseNode"); //action
}

const viewOptions = [
  {
    mode: "RAW",
    icon: filesIcon,
    tooltip: "By Data Format",
  },
  {
    mode: "BY_TOPIC",
    icon: chatIcon,
    tooltip: "By Topic",
  },
  {
    mode: "BY_SENDER",
    icon: contactIcon,
    tooltip: "By Email Sender",
  },
  {
    mode: "BY_MAILBOX",
    icon: mailboxIcon,
    tooltip: "By Mailbox",
  },
  {
    mode: "BY_TAG",
    icon: classificationIcon,
    tooltip: "By Classification",
  },
];

function loadNode(node) {
  console.log("🚀 ~ loadNode ~ node:", node);
  clickedParentId.value = node;
  store.commit("nodeIdSelected", node); //mutation
  store.dispatch("emailKnowledgeBaseNode"); //action
}

function handleDivClick(e) {
  console.log("🚀 ~ handleDivClick ~ e:", e);
  // Only fire if the clicked element is the parent div, not its children
  if (e.target.closest(".exclude-me")) {
    return; // Stop handling if the excluded child or its children are clicked
  }
}

const documentTypes = ["pdf", "documents2", "pics", "calendarevent", "csv", "music", "video"];
const documentName = ref("");

const getPopupWidth = function () {
  return $(window).width() * 0.8;
};
const getPopupH = function () {
  return $(window).height();
};
const popupWidth = getPopupWidth();
const popupH = getPopupH();

let showPopup = ref(false);

const filterToConceptKeyMap = computed(() => store.getters.filterToConceptKeyMap);
let setFilter = null;

setTimeout(() => {
  setFilter = computed(() => store.getters.tagsFilter);
}, 500);

function addFilter(filter) {
  console.log("🚀 ~ addFilter ~ filter:", filter);
  store.commit("tagsFilter", filter);

  if (!filter.value.type) treeViewInstance.value.instance.collapseAll();

  // Set view mode to BY_TAG when using tag filters
  // selectedView.value = "BY_TAG";
  // store.commit("heirarchyMode", "BY_TAG");

  // Trigger data loading with the filter applied
  store.commit("nodeIdSelected", "0"); // Start from root node
  store.dispatch("emailKnowledgeBaseNode").then(() => {
    // After data is loaded, try to find and expand the first relevant node
    nextTick(() => {
      // Get the filtered tree data
      const filteredData = treeViewData.value;

      if (filteredData && filteredData.length > 0) {
        // Find the first root node in the filtered data
        const firstRootNode = filteredData.find(
          (item) => !item.parentId || item.parentId === "0"
        );

        if (firstRootNode) {
          // Load this node's children
          loadNode(firstRootNode.id);

          // Expand this node in the tree
          treeViewInstance.value.instance.expandItem(firstRootNode.id);
        }
      }
    });
  });
}

let KBInSearchMode = ref(false);

// Computed property to check if we should show "no search results" message
const showNoSearchResults = computed(() => {
  return KBInSearchMode.value && treeViewData.value.length === 0;
});

// Computed property to determine when to show the skeleton loader
const shouldShowLoader = computed(() => {
  if (store.getters.isSearchLoading) return true;
  if (showNoSearchResults.value) return false;
  return (
    isLoading.value ||
    (!KBInSearchMode.value && treeViewData.value.length === 0)
  );
});

const treeViewData = computed(() => {
  maintainScrollPosition();
  const data = [...store.getters.emailKnowledgeBase.KB];

  if (store.getters.emailKnowledgeBase.search) {
    KBInSearchMode.value = true;
  } else {
    KBInSearchMode.value = false;
  }
  //alert(`dataSource trigger with data get ${data}`)
  const filter = store.getters.tagsFilter;
  console.log("🚀 ~ treeViewData ~ filter:", filter);

  clickedParentId.value = null;

  if (filter) {
    //console.log(data.map(item => item.icon + " = " + item.concept ));
    //TODO check if this is not in the list - its then a specific classification
    var concept = filterToConceptKeyMap[filter] || 23;

    return data.filter(
      (item) => item.concept === concept || item.concept === 0
    );
  }
  return data;
});

watch(KBInSearchMode, async (newVal) => {
  if (newVal) {
    treeViewInstance.value.instance.expandAll();
    await nextTick();
    const data = treeViewData.value;
    const topLevelItemThatShouldExpand = data.filter(item => 
    (!item.parentId || item.parentId === 0) && item.expanded === true && item.hasItems)

    for (const item of topLevelItemThatShouldExpand) {
// DONT EXPAND ANYTHING FOR NOW
      // item.expanded = false;
    // treeViewInstance.value.instance.expandItem(item.id);
      // loadNode(item.id)
    }
  } else {
    treeViewInstance.value.instance.collapseAll();
  }
});

watch(treeViewData, (newVal, oldVal) => {
  treeViewInstance.value.instance.option("items", newVal);
  // Set loading to false when we have data or when we're in search mode (even with no results)
  if (newVal.length > 0 || KBInSearchMode.value) {
    isLoading.value = false;
  }
});

async function maintainScrollPosition() {
  let el = document.querySelector(".tree-view-container");
  if (!el) return;
  const treeViewElement = el.closest(".dx-scrollable-container");

  const scrollTop = treeViewElement?.scrollTop;

  await nextTick();
  if (treeViewElement) {
    treeViewElement.scrollTop = scrollTop;
  }
}

function selectItem(e) {
  console.info("🚀 ~ selectItem ~ e:", e);
  // if (KBInSearchMode.value) return;
  //alert(`${JSON.stringify(e)}`);
  //alert(e.itemData.id);
  loadNode(e.itemData.id);
  maintainScrollPosition();

  e.itemData.expanded = e.node.expanded;

  e.event.preventDefault();
  documentName.value = e.itemData.name;
  console.log(e.itemData.uh);

  if (!e.itemData.isInteractive) return;

  if (documentTypes.includes(e.itemData.icon)) {
    return getDocument(e);
  } else if (e.itemData.icon == "email2") {
    //alert(JSON.stringify(e.itemData));
    return populateEmailCard(e);
  }
  /*   else if (e.itemData.icon == "user") {
    return showUserCard(e);
  } */
}

const getDocument = async (item) => {
  console.log("📃 ~ getDocument ~ ICON/TYPE:{} ", item.itemData);
  // currentDisplayType.value = "document";
  await store.dispatch("getDocumentFromServerLocalPath", item.itemData);

  currentComponent.value = DocumentViewer;
  componentProps.value = {
    documentType: item.itemData.icon,
    documentName: item.itemData.name,
  };

  showPopup.value = true;
};



const populateEmailCard = async (e) => {
  const raw = e.itemData;

  await store.dispatch("getEmailBodyFromCompositeKey", raw);

  const safeData = {
    id: raw.id,
    name: raw.name,
    subject: raw.subject,
    from: raw.from,
    to: raw.to,
    icon: raw.icon,
    uh: raw.uh,
  };
  
  componentProps.value = markRaw({
    cardData: [safeData],
  });

  if (!componentProps.value?.cardData?.length) {
    return; // do nothing
  }

  currentComponent.value = markRaw(EmailCard);

  await nextTick();

  showPopup.value = true;
};

const showUserCard = (e) => {
  let data = e.itemData;

  currentComponent.value = UserViewer;
  componentProps.value = { userData: data };

  showPopup.value = true;
};

// Dynamic props based on the display type
let componentProps = ref({});

function closeCard() {
  componentProps.value = {};
}

watch(showPopup, (newVal) => {
  if (newVal) {
    clickedParentId.value = null;
  }
});

watchEffect(async () => {
  if (!clickedParentId.value || !treeViewInstance.value) return;

  await nextTick(); // Wait for DOM updates

  const instance = treeViewInstance.value.instance;
  instance.expandItem(clickedParentId.value);
  // instance.expandAll();

  // clickedParentId.value = null; // Reset after expanding
});
</script>

<style>
.no-search-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #666;
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 20px 0;
}

.no-results-icon {
  font-size: 48px;
  margin-bottom: 20px;
  opacity: 0.6;
}

.no-results-text h3 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 18px;
  font-weight: 600;
}

.no-results-text p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

.email-kb-container .dx-treeview-toggle-item-visibility {
  /* height: 100%; */
}

.bigger {
  font-size: 24px;
  color: rgba(0, 0, 0, 0.54);
}

.placement-to-left-of-node {
  position: absolute;
  top: 24px;
  transform: translateY(-50%);
  left: 0px;
}
.kbChoice {
  width: 70px;
  cursor: pointer;
}

.document-popup .dx-popup-title {
  border: none;
  color: #fff;
}

.document-popup .dx-overlay-content {
  background-color: #3b3b3bc7;
}

.document-popup .dx-popup-content {
  padding-top: 0;
}

.document-popup .dx-item-content {
  user-select: text;
}

.document-popup .dx-icon-close {
  color: white;
}

.email-kb-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.email-kb-select-box {
  position: fixed;
  top: 0;
  right: 0;
  margin: auto;
  z-index: 1;
}

.dx-popup-wrapper .dx-popup-normal {
  /* width: fit-content !important;
  height: fit-content !important; */
  display: inline-block;
  width: auto;
  height: auto;
}
.tree-view-container .flex {
  overflow-y: auto;
  display: flex;
  align-items: center;
  margin: 0 !important;
}

.tree-view-container {
  position: relative;
  height: 100%;
}

.popup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}

.text {
  padding: 0 0 4px 10px;
}

/* TOOLTIP  */
.tooltip-container.selected {
  background-color: rgba(0, 123, 255, 0.1);
  border-radius: 10px;
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
  transform: scale(1.05);
}

.tooltip-container.selected .kbChoice {
  /* transform: scale(1.1); */
}

/* Modified existing tooltip-container style for smooth transition */
.tooltip-container {
  position: relative;
  display: inline-block;
  margin: 10px;
  padding: 5px;
  transition: all 0.3s ease;
  border-radius: 10px;
}

.tooltip {
  visibility: hidden;
  opacity: 0;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px 10px;
  position: absolute;
  z-index: 10;

  /* Position LEFT of the element */
  right: 50px;     /* Move tooltip left of the target */
  top: 50%;
  transform: translateX(-50%);

  white-space: nowrap;
  font-size: 14px;
  transition: opacity 0.3s ease, transform 0.3s ease;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

/* Arrow pointing RIGHT */
.tooltip::after {
  content: "";
  position: absolute;

  /* Arrow centered vertically */
  top: 50%;
  left: 100%;  /* Put arrow on right side of tooltip */
  transform: translateY(-50%);

  border-width: 5px;
  border-style: solid;

  /* Arrow pointing RIGHT: left border has color */
  border-color: transparent transparent transparent #333;
}

.tooltip-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(-5px); /* Slight upward animation */
}

.kbChoice {
  width: 70px;
  cursor: pointer;
  transition: transform 0.3s ease;
}
</style>
